import { Component } from '@angular/core';
import { HeaderComponent } from '@plantefeve/common/shared/components/header/header.component';

@Component({
  selector: 'igx-no-access',
  imports: [HeaderComponent],
  template: `
    <igx-header title="Geen toegang"></igx-header>
    <p class="px-4">
      Je hebt geen toegang tot deze pagina. Neem contact op met een beheerder als je deze pagina nodig hebt.
    </p>
  `,
})
export class NoAccessComponent {}
